import { RiEyeLine } from '@remixicon/react';
import { useSideDrawer } from 'src/components/containers/SideDrawer';
import { AgButton } from 'src/components/ui';

export default function DownloadInvoice() {
  const { openDrawer } = useSideDrawer();

  return (
    <div className="flex items-center">
      <AgButton
        variant="ghost"
        onPress={() => {
          openDrawer(null);
        }}
      >
        <RiEyeLine size={20} />
        Invoice Document Preview
      </AgButton>
    </div>
  );
}
